import { render, staticRenderFns } from "./UserCustomersDialog.vue?vue&type=template&id=70a32c88"
import script from "./UserCustomersDialog.vue?vue&type=script&lang=js"
export * from "./UserCustomersDialog.vue?vue&type=script&lang=js"
import style0 from "./UserCustomersDialog.vue?vue&type=style&index=0&id=70a32c88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports